module.exports = __webpack_public_path__ + "media/fall_2023_sweepstakes/twitter-social-icon-ff6f72de.svg";